import type { CSSProperties, FC } from 'react';
import { cx } from '../../../utils/cx';
import { IconCamera, IconDownload, IconSpinner } from '../../../assets/icons/icons';
import type { ScreenshotsState } from '../../../entities/project/model/screenshots';
import styles from './ScreenshotsButton.module.scss';

interface ScreenshotsButtonProps {
    state: ScreenshotsState;
    busy?: boolean;
    onClick: () => void;
}

export const ScreenshotsButton: FC<ScreenshotsButtonProps> = ({ state, busy = false, onClick }) => {
    const { kind, label, hint, disabled, progress } = state;

    if (kind === 'progress') {
        const percent = progress ?? 0;

        return (
            <button
                type="button"
                className={cx(styles.btn, styles.progress)}
                style={{ '--p': `${percent}%` } as CSSProperties}
                title={hint}
                disabled
                aria-busy="true"
                aria-label={
                    progress === undefined ? 'Создаём скриншоты' : `Создаём скриншоты, ${percent}%`
                }
            >
                <i className={styles.fill} />
                <span>{label}</span>
                <b>{progress === undefined ? '…' : `${percent}%`}</b>
            </button>
        );
    }

    const icon = busy
        ? <span className={styles.spinner}><IconSpinner /></span>
        : kind === 'download' ? <IconDownload /> : <IconCamera />;

    return (
        <button
            type="button"
            className={cx(styles.btn, kind === 'download' && styles.download)}
            title={hint}
            disabled={disabled || busy}
            onClick={onClick}
        >
            {icon}
            <span>{label}</span>
        </button>
    );
};